export default __webpack_public_path__ + "static/favicon-96x96-decd2d8d8efc59a3d2798ea5a6d53ba8.png";